import { createFileRoute } from '@tanstack/react-router'
import { ADMIN_FEEDBACK_FILTER_KEYS } from '@/features/feedback/components/feedback/admin-feedback-columns'
import { AdminFeedbackPage } from '@/features/feedback/pages/admin-feedback-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const feedbackSearchSchema = createTableSearchSchema({
  defaultPageSize: 25,
  filterKeys: ADMIN_FEEDBACK_FILTER_KEYS,
})

export const Route = createFileRoute('/feedback')({
  staticData: { title: 'Feedback' },
  validateSearch: feedbackSearchSchema,
  component: AdminFeedbackPage,
})
